import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { BlogsComponent } from './blogs.component';
import { PendingChangesGuard } from '../shared/pending-changes.guard';

export const BLOGS_ROUTES: Routes = [
  {
    path: 'blogs', component: BlogsComponent, canActivate: [AuthGuard], children: [
      { path: '', component: BlogsComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard] },
      { path: '**', redirectTo: 'blogs' }
    ]
  }
];
